/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useContext } from "react";
import { AppContext } from "../../context";

const KlarnaReceipt = (props) => {
  const { saleId } = props;

  const { state } = useContext(AppContext);
  const { config } = state;

  //On first render - Call external api
  useEffect(() => {
    const loadReceipt = async () => {
      const uri = `${config.apiUri}/api/klarna/v3/status/${saleId}`;
      const apiResponse = await fetch(uri, {
        method: "GET",
        headers: new Headers({
          "Content-Type": "application/json",
        }),
      });

      if (apiResponse.status === 200) {
        let response = await apiResponse.json();

        //Apply payload
        var checkoutContainer = document.getElementById(
          "receipt-container-div"
        );
        checkoutContainer.innerHTML = response.snippet;
        var scriptsTags = checkoutContainer.getElementsByTagName("script");

        for (var i = 0; i < scriptsTags.length; i++) {
          var parentNode = scriptsTags[i].parentNode;
          var newScriptTag = document.createElement("script");
          newScriptTag.type = "text/javascript";
          newScriptTag.text = scriptsTags[i].text;
          parentNode.removeChild(scriptsTags[i]);
          parentNode.appendChild(newScriptTag);
        }
      }
    };

    loadReceipt();
  }, []);

  return <div id="receipt-container-div"></div>;
};

export default KlarnaReceipt;
